import SetupPayrollStep from "./SetupPayrollStep";

export default SetupPayrollStep;
